import { Box, Button, Stack, styled } from "@mui/material";
import { baseUrl } from "../../../../../../shared/config";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useParams } from "react-router-dom";
import PreviewMarker from "../../partials/PreviewMarker";
import { useRef } from "react";
import getFileExtension from "../../../../../../shared/utils/getFileExtension";
import { useRegisterView } from "../../../../../../features/quadrants/api/registerView";
import { useQuadrantViewedStatus } from "../../../../../../features/quadrants/api/getQuadrantViewedStatus";
import { useWaterMark } from "../../../../../../features/quadrants/hooks/useWaterMark";
import { ArrowUpward } from "@mui/icons-material";
import { ArrowDown } from "mdi-material-ui";
import PDFViewer from "../../../../../components/PDFViewer";

const StyledEmbed = styled("iframe")(({ theme }) => ({
  width: "100%",
  height: "100%",
}));

function DocContent({
  contentId,
  mandatory,
  value,
  auth,
  enrollment,
  chapters,
  isConfidential,
  size = { width: 500, height: 500 },
  ...rest
}) {
  const { currentChapter } = useParams();
  const watermarkCn = useWaterMark();
  const quadrantViewedStatusQuery = useQuadrantViewedStatus({
    quadrantId: contentId,
    chapterId: currentChapter,
    enrollmentId: enrollment?.MATRICULAID,
  });

  const registerViewMutation = useRegisterView();

  const handleClickView = () => {
    if (!quadrantViewedStatusQuery.data?.viewed) {
      registerViewMutation.mutate({
        enrollmentId: enrollment?.MATRICULAID,
        quadrantId: contentId,
      });
    }
  };

  const documentUrl = !!value
    ? value?.includes("https")
      ? value
      : baseUrl + "/" + value
    : "";

  const officeDocExtensions = [
    ".doc",
    ".docx",
    ".xls",
    ".xlsx",
    ".ppt",
    ".pptx",
  ];

  const fileExtension = getFileExtension(documentUrl).toLowerCase();
  const isOffice =
    !!documentUrl &&
    officeDocExtensions.some((extension) => {
      return fileExtension === extension;
    });

  const formattedUrl = isOffice
    ? `https://view.officeapps.live.com/op/embed.aspx?src=${documentUrl}`
    : fileExtension === ".pdf"
      ? `${documentUrl}#toolbar=0&navpanes=0&view=fit`
      : documentUrl;
  const ref = useRef();
  const wrapperRef = useRef();
  const { width, height } = size;

  switch (fileExtension) {
    case ".pdf":
      return (
        <Box
          sx={{
            height: "100%",
            width,
            display: "block",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          {mandatory === "S" && (
            <Box
              sx={{
                position: "absolute",
                top: "0",
                cursor: "pointer",
              }}
              onClick={handleClickView}
            >
              <PreviewMarker
                viewed={quadrantViewedStatusQuery.data?.viewed}
                TooltipValue={"Leia o conteúdo e clique aqui"}
              />
            </Box>
          )}
          <PDFViewer
            DocumentProps={{ className: "h-full w-full" }}
            PageProps={{
              width,
              enableWatermark: isConfidential,
            }}
            file={formattedUrl}
            onLastPageVisible={mandatory === "S" ? handleClickView : undefined}
          />
        </Box>
      );
    default:
      return (
        <Box
          sx={{
            position: "relative",
            height: "100%",
            flexGrow: 1,
            display: "flex",
          }}
        >
          <Box
            ref={wrapperRef}
            sx={{
              position: "relative",
              width: "100%",
              height: "100%",
            }}
            id={`document-wrapper-${contentId}`}
            className={isConfidential && watermarkCn.WatermarkPdf}
          >
            <StyledEmbed
              ref={ref}
              sx={{
                position: "absolute",

                ...(getFileExtension(documentUrl).toLowerCase().includes("ppt")
                  ? {
                      aspectRatio: "16 / 9",
                      height: "100%",
                      // width: "100%",
                      width: "auto",
                    }
                  : {
                      height: "100%",
                      width: "100%",
                    }),
                //ESSE VALOR SERVE PRA CONCERTAR OS POWERPOINTS
                top: "0",
                left: "50%",
                transform: "translateX(-50%)",
              }}
              id={`document-${contentId}`}
              src={formattedUrl}
            />
          </Box>
          {isConfidential && (
            <div className={watermarkCn.WatermarkAbsolute}></div>
          )}
          {mandatory === "S" && (
            <Box
              sx={{
                position: "absolute",
                top: "0",
                cursor: "pointer",
              }}
              onClick={handleClickView}
            >
              <PreviewMarker
                viewed={quadrantViewedStatusQuery.data?.viewed}
                TooltipValue={"Leia o conteúdo e clique aqui"}
              />
            </Box>
          )}
        </Box>
      );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  enrollment: state.course?.enrollment,
  chapters: state.course?.chapters,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DocContent);
